'use client';

import React from 'react';

import { useParams } from 'next/navigation';

import styles from './styles.module.css';

import { DownloadAppButton } from '@/components/DownloadAppButton';
import { DownloadAppQRCodeSection } from '@/components/DownloadAppQRCodeSection';
import { useBlogTracking } from '@/modules/blog/hooks/useBlogTracking';

export function ArticleFooter() {
  const { sendBlogInteractionActionEvent } = useBlogTracking();
  const { slug } = useParams<{ slug: string }>();

  return (
    <div className={styles.footer}>
      <DownloadAppQRCodeSection size="md" placement="blog_article" />
      <DownloadAppButton
        className={styles.appDownloadButton}
        trackingId="blog_article"
        onClick={() =>
          sendBlogInteractionActionEvent({
            articleSlug: slug,
            interactionType: 'ArticleDownloadAppClick',
          })
        }
      />
    </div>
  );
}
